export const getFilteredOutModifiersFromParentItem = (CartItems = []) => {
  return CartItems.reduce((a, v) => {
    const obj = { ...v };
    if (v.hasLinkedMenuItem && Array.isArray(obj.modifiers)) {
      obj.modifiers = obj.modifiers.filter(m => !m.isLinkedItem);
    }
    a.push(obj);
    return a;
  }, []);
};
